import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Wallet } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/financials')({
    staticData: {
        breadcrumb: {
            title: 'Financial',
            inactive: true,
        },
        // CUR-2808: the Accounts role reads Bank account, so the group opens for them too; every other
        // section and page directly under it sets its own permissions (`configuration-access.test.ts`).
        permissions: [...ORG_CONFIG_PERMISSIONS, 'org_bank_account:read'],
        ui: {
            icon: Wallet,
        },
    },
    component: Outlet,
});
